var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title-create")) + " "),
          _c("w-spacer"),
          _vm.isManual
            ? _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.step == 0
        ? _c(
            "w-scroll-view",
            { attrs: { tag: "div" } },
            [
              _c("w-card-content", [
                _vm._v(_vm._s(_vm.$ct("ask-change-numbers"))),
              ]),
              _c("app-settings-friendly-ids", {
                attrs: {
                  "reset-friendly-config": true,
                  bookyear: _vm.toCreateYear,
                  "show-items-with-partition": true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.step == 1
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$ct("steps.create-new-bookyear")) +
                        " (" +
                        _vm._s(_vm.toCreateYear) +
                        ") "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("steps.copy-sales") },
                        model: {
                          value: _vm.copySales,
                          callback: function ($$v) {
                            _vm.copySales = $$v
                          },
                          expression: "copySales",
                        },
                      }),
                      _c(
                        "w-link",
                        {
                          attrs: {
                            to: _vm.$ct("copy-sales-link"),
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("copy-sales-info")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("steps.copy-purchases") },
                        model: {
                          value: _vm.copyPurchases,
                          callback: function ($$v) {
                            _vm.copyPurchases = $$v
                          },
                          expression: "copyPurchases",
                        },
                      }),
                      _c(
                        "w-link",
                        {
                          attrs: {
                            to: _vm.$ct("copy-purchases-link"),
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("copy-purchases-info")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("steps.copy-stock") },
                        model: {
                          value: _vm.copyStock,
                          callback: function ($$v) {
                            _vm.copyStock = $$v
                          },
                          expression: "copyStock",
                        },
                      }),
                      _c(
                        "w-link",
                        {
                          attrs: {
                            to: _vm.$ct("copy-stock-link"),
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("copy-stock-info")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("steps.copy-backorder-sales") },
                        model: {
                          value: _vm.copyBackorderSales,
                          callback: function ($$v) {
                            _vm.copyBackorderSales = $$v
                          },
                          expression: "copyBackorderSales",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("steps.copy-bank-saldos") },
                        model: {
                          value: _vm.copyBankSaldos,
                          callback: function ($$v) {
                            _vm.copyBankSaldos = $$v
                          },
                          expression: "copyBankSaldos",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.step == 2
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [_c("w-progress-circular", { attrs: { large: "" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          !_vm.isManual
            ? _c(
                "w-button",
                {
                  staticClass: "cancel",
                  on: {
                    click: function ($event) {
                      return _vm.logout()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("logout")) + " ")]
              )
            : _vm._e(),
          _c("w-spacer"),
          _vm.step == 0
            ? _c(
                "w-button",
                {
                  attrs: { icon: "arrow-right" },
                  on: {
                    click: function ($event) {
                      _vm.step = 1
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.next")) + " ")]
              )
            : _vm._e(),
          _vm.step == 1
            ? _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.createNewBookYear()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("create-new-bookyear")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }